module.exports = __webpack_public_path__ + "static/img/common.bd272395.png";